
import styled from '@emotion/styled';
import type { StylesConfig } from 'react-select';
import { dropdownWrapper } from 'src/assets/colors';

export const OptionWrapper = styled('div', { label: 'OptionWrapper' })<{ isSelected?: boolean }>`
    background-color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColor};
    color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    padding: 8px 10px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    font-weight: 400;
    white-space: nowrap;
    vertical-align: middle;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${(props): string => props.isSelected === true ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColorHover};
        color: ${dropdownWrapper.option.txtColorSelected};
    }
`;

export const OptionWithDeleteWrapper = styled(OptionWrapper, { label: 'OptionWithDeleteWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const DeleteButton = styled('button', { label: 'DeleteButton' })`
    margin-left: auto;
    padding: 2px 5px;
    background: ${dropdownWrapper.deleteButton.bgColor};
    border: 1px solid ${dropdownWrapper.deleteButton.borderColor};
    cursor: pointer;
    border-radius: 2px;
    font-size: 12px;
    line-height: 1;
    flex-shrink: 0;

    &:hover {
        background: ${dropdownWrapper.deleteButton.bgColorHover};
        color: ${dropdownWrapper.deleteButton.txtColor};
        border-color: ${dropdownWrapper.deleteButton.bgColorHover};
    }
`;

export const SelectInputContainer = styled('div', { label: 'SelectInputContainer' })`
    height: 100%;
    margin: 0;
    position: relative;
`;

export const SelectInputWrapper = styled('div', { label: 'SelectInputWrapper' })`
    border-radius: 3px;
    margin: 5px 0;
    position: relative;
`;

export const getPaymentMethodDropdownStyles = <T, IsMulti extends boolean>(): StylesConfig<T, IsMulti> => ({
    singleValue: (base) => ({
        ...base,
        fontSize: '14px',
    }),
});
